import { ICostCenter } from '../common/data/dtos/coster-center';
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/CostCenter';

interface CostCenterResponse {
	success: boolean;
	costCenter?: ICostCenter;
	costCenters?: ICostCenter[];
	error?: string;
}

type CreateCostCenterType = Omit<ICostCenter, 'id'> | Partial<ICostCenter>;

const createCompany = async (costCenter: CreateCostCenterType): Promise<CostCenterResponse> => {
	try {
		const response = await POST_TYPED_ASYNC<ICostCenter>(`${BASE_PATH}`, costCenter);
		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const getCostCenters = async (): Promise<CostCenterResponse> => {
	try {
		const response = await GET_TYPED_ASYNC<ICostCenter>(`${BASE_PATH}`);

		if (!response.success) {
			return { success: response.success, error: response.message || response.exception };
		}

		return { success: response.success, costCenters: response.collection };
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const deleteCostCenter = async (id: string): Promise<CostCenterResponse> => {
	try {
		const response = await DELETE_TYPED_ASYNC<ICostCenter>(`${BASE_PATH}/${id}`);

		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

const updateCostCenter = async (costCenter: ICostCenter): Promise<CostCenterResponse> => {
	try {
		const response = await PUT_TYPED_ASYNC<ICostCenter>(`${BASE_PATH}/${costCenter.id}`, costCenter);
		return {
			success: response.success,
			...(!response.success ? { error: response.message || response.exception } : null),
		};
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

export default {
	getCostCenters,
	deleteCostCenter,
	updateCostCenter,
	createCompany,
};
